// TODO: Need Audit Separate Constructor

import AhoyTracker from 'shared/ahoy_tracker';
import GTMTracker from 'shared/gtm_tracker';

export default class NativeComponentInitializers {
  constructor() {
    this.initJsComponent();
    this.initJsGTM();
    this.initJsAhoy();
  }

  initJsComponent() {
    let elements = Array.prototype.slice.call(document.getElementsByClassName('js-component'));

    for(var i = 0; i < elements.length; i++) {
      let element = elements[i];
      let componentClass = element.dataset.component;

      if(window[componentClass] && typeof window[componentClass] === 'function' && element.dataset.loaded !== 'true') {
        let component = new window[componentClass]({ $element: $(element), element: element });

        if(typeof component.init === 'function'){
          component.init();
        }

        element.dataset.loaded = 'true';
      }
    }
  }

  initJsGTM() {
    let elements = Array.prototype.slice.call(document.getElementsByClassName('js-gtm'));

    for(var i = 0; i < elements.length; i++) {
      let element = elements[i];
      if(element.dataset.gtmloaded !== 'true'){

        var gtm_tracker = new GTMTracker(element);
        gtm_tracker.init();

        element.dataset.gtmloaded = 'true';
      }
    }
  }

  initJsAhoy() {
    let elements = Array.prototype.slice.call(document.getElementsByClassName('js-ahoy'));

    for(var i = 0; i < elements.length; i++) {
      let element = elements[i];
      var ahoy_tracker = new AhoyTracker(element);
      ahoy_tracker.init();
    }
  }
}

